export default __webpack_public_path__ + "static/media/paymentEmptyState.30f6fa87.svg";